import React, { useEffect, useState, useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import { API_URL } from '../config.js';

import './NivelBasico.css';

import AlternativasGraficas from './AlternativasGraficas';

import ChatWidget from '../components/ChatWidget';

import Images3Question from './Images3Question';

import WarningVidas from '../components/WarningVidas.jsx';



// ==== Carga dinámica de imágenes por carpeta ====

const imgRoles = {};

const imgGenerales = {};

const img3 = {};



function resolveAny(key) {

  return (imgRoles && imgRoles[key]) || (imgGenerales && imgGenerales[key]);

}



function keyFrom(name) {

  return String(name || '')

    .replace(/\.(png|jpe?g|svg|webp)$/i, '')

    .toLowerCase()

    .normalize('NFKD')

    .replace(/[\u0300-\u036f]/g, '')

    .replace(/[\s-]+/g, '_');

}

function importAll(ctx, target) {

  ctx.keys().forEach((key) => {

    const clean = key.replace('./', '');

    target[keyFrom(clean)] = ctx(key);

  });

}

importAll(require.context('../assets/img_roles', false, /\.(png|jpe?g|svg|webp)$/), imgRoles);

importAll(require.context('../assets/img_generales', false, /\.(png|jpe?g|svg|webp)$/), imgGenerales);

importAll(require.context('../assets/img_3imagenes', false, /\.(png|jpe?g|svg|webp)$/), img3);



const fondo = imgGenerales['fondo'];



const NivelAvanzado = () => {

  const navigate = useNavigate();

  const [cargando, setCargando] = useState(true);

  const [mostrarEfectoEnPantalla, setMostrarEfectoEnPantalla] = useState(false);

  const [textoEfectoPantalla, setTextoEfectoPantalla] = useState('');

  const [modoError, setModoError] = useState(false);

  const [preguntaPendiente, setPreguntaPendiente] = useState(null);

  const [preguntas, setPreguntas] = useState([]);

  const [preguntaActual, setPreguntaActual] = useState(null);

  const [posicionX, setPosicionX] = useState(0);
  // Swipe: seleccionar no modifica puntaje, registros ni vidas.
  const [swipePendiente, setSwipePendiente] = useState(null);
  const confirmandoSwipeRef = useRef(false);

  const [startX, setStartX] = useState(null);

  const [usuario, setUsuario] = useState('Jugador');

  const [puntaje, setPuntaje] = useState(0);

  const puntajeRef = useRef(0);

  const [tiempo, setTiempo] = useState(0);

  const tiempoRef = useRef(0);

  const [tiempoInicioCaso, setTiempoInicioCaso] = useState(null);

  const [vidas, setVidas] = useState(5);

  const [mostrarImagen, setMostrarImagen] = useState(false);

  const [ultimoCaso, setUltimoCaso] = useState(null);

  const ultimoCasoGuardado = useRef(null);

  const historialWriteQueueRef = useRef(Promise.resolve());

  const finalizandoRef = useRef(false);

  const handleEndCalledRef = useRef(false);

  const [mostrarResumen, setMostrarResumen] = useState(false);

  const sessionIdRef = useRef(

    `SESS_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`

  );

  const perdioPorVidasRef = useRef(false);

  const [resultadoFinal, setResultadoFinal] = useState(null);



  const [bloquearInteraccion, setBloquearInteraccion] = useState(false);



  const [mostrarOpciones, setMostrarOpciones] = useState(true);

  const [mostrarCartaFin, setMostrarCartaFin] = useState(false);

  const [esperarOk, setEsperarOk] = useState(false);



  const [areasPlan, setAreasPlan] = useState({});

  const [areasLogro, setAreasLogro] = useState({});

  const areasPlanRef = useRef({});

  const areasLogroRef = useRef({});



  const [totalPlan, setTotalPlan] = useState(0);

  const [totalLogro, setTotalLogro] = useState(0);

  const totalPlanRef = useRef(0);

  const totalLogroRef = useRef(0);



  const hayImagenValida = !!resolveGeneral(preguntaActual?.Imagen || preguntaActual?.ImagenGral);



  const inputTipo = useRef(null);

  const getTipo = (p) => {

    const raw = (p?.TipoPregunta || 'swipe')

      .toString()

      .trim()

      .toLowerCase()

      .normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

    const alias = {

      'alternativas graficas': 'alternativasgraficas',

      'alternativas_graficas': 'alternativasgraficas',

      'alternativasgraficas': 'alternativasgraficas',

      'imagenmarcas': 'alternativasgraficas',

      'alternativas gráficas': 'alternativasgraficas',

      '3 imagenes': 'imagenes3',

      '3_imagenes': 'imagenes3',

      '3 imágenes': 'imagenes3',

      'tres imagenes': 'imagenes3',

      'tres_imagenes': 'imagenes3',

    };

    return alias[raw] || raw;

  };



  function resolveRol(rol) { return imgRoles[keyFrom(rol)] || imgRoles['enfermera'] || null; }

  function resolveGeneral(nombre) { return imgGenerales[keyFrom(nombre)] || null; }

  function resolveImg3(nombre) { return img3[keyFrom(nombre)] || null; }



  const presentOptionsKeys = ['A', 'B', 'C', 'D'];

  function parseIntSafe(v) {

    const n = parseInt(String(v ?? '').trim(), 10);

    return isNaN(n) ? 0 : n;

  }

  function isInfoValue(v) {

    const s = String(v ?? '')

      .toLowerCase()

      .normalize('NFKD')

      .replace(/[\u0300-\u036f]/g, '')

      .trim();

    return s === 'info';

  }

  function maxPositiveForQuestion(p) {

    let best = 0;

    for (const k of presentOptionsKeys) {

      const raw = p[`Puntaje${k}`];

      if (isInfoValue(raw)) continue;

      const val = parseIntSafe(raw);

      if (val > best) best = val;

    }

    return best;

  }

  function areaOf(p) {

    const a = (p?.TipoEvaluacion || '').toString().trim();

    return a;

  }

  function computeTotalPlan(preguntasArr) {

    let sum = 0;

    for (const p of preguntasArr || []) {

      const best = maxPositiveForQuestion(p);

      if (best > 0) sum += best;

    }

    return sum;

  }

  function computePlanByArea(preguntasArr) {

    const acc = {};

    for (const p of preguntasArr || []) {

      const area = areaOf(p);

      if (!area) continue;

      const best = maxPositiveForQuestion(p);

      if (best > 0) {

        acc[area] = (acc[area] || 0) + best;

      }

    }

    return acc;

  }

  function recordAreaLogroDelta(delta) {

    const n = parseIntSafe(delta);

    if (n <= 0) return;

    const area = areaOf(preguntaActual);

    if (!area) return;



    const nuevoLogroAreas = {

      ...areasLogroRef.current,

      [area]: (areasLogroRef.current[area] || 0) + n

    };



    areasLogroRef.current = nuevoLogroAreas;

    setAreasLogro(nuevoLogroAreas);

  }



  const handleMove = (x) => {
    if (startX !== null && !bloquearInteraccion && !swipePendiente &&
        !mostrarImagen && getTipo(preguntaActual) === 'swipe') {
      setPosicionX(x - startX);
    }
  };

  // Cancelar una respuesta pendiente sin modificar datos ni vidas.
  const cancelarSwipe = () => {
    setSwipePendiente(null);
    setPosicionX(0);
    setStartX(null);
    inputTipo.current = null;
    handleEndCalledRef.current = false;
  };

  // Si se toca fuera de la alternativa verde, se cancela sin registrar.
  useEffect(() => {
    if (!swipePendiente) return undefined;
    const cancelarAlTocarFuera = (event) => {
      if (event.target.closest?.('.opcion-swipe-confirmable')) return;
      cancelarSwipe();
    };
    document.addEventListener('pointerdown', cancelarAlTocarFuera, true);
    return () => document.removeEventListener('pointerdown', cancelarAlTocarFuera, true);
  }, [swipePendiente]);

  useEffect(() => {

    const setVh = () => {

      const vh = window.innerHeight * 0.01;

      document.documentElement.style.setProperty('--vh', `${vh}px`);

    };

    setVh();

    window.addEventListener('resize', setVh);

    return () => window.removeEventListener('resize', setVh);

  }, []);



  useEffect(() => {

    const nombre = localStorage.getItem('usuario');

    if (nombre) setUsuario(nombre);



    localStorage.setItem('sesion', sessionIdRef.current);



    const fetchPreguntas = async () => {

      try {

        const res = await fetch(`${API_URL}/preguntas-nivel-avanzado?ts=${Date.now()}`);

        const data = await res.json();

        const arr = Array.isArray(data) ? data : (data.preguntas || []);

        const normal = arr.map(p => ({ ...p, ID: String(p.ID || '').trim() }));

        const inicial = normal.find(p => p.ID === '2') || normal[0];

        setPreguntas(normal);

        setPreguntaActual(inicial || null);



        const planAreas = computePlanByArea(normal);

        areasPlanRef.current = planAreas;

        setAreasPlan(planAreas);



        const planTotal = computeTotalPlan(normal);

        totalPlanRef.current = planTotal;

        setTotalPlan(planTotal);



        areasLogroRef.current = {};

        totalLogroRef.current = 0;

        setAreasLogro({});

        setTotalLogro(0);

      } catch (error) {

        console.error('❌ Error cargando preguntas:', error);

      } finally {

        setCargando(false);

      }

    };

    fetchPreguntas();

  }, []);



  useEffect(() => {

    const interval = setInterval(() => {

      setTiempo((t) => {

        const nuevoTiempo = t + 1;

        tiempoRef.current = nuevoTiempo;

        return nuevoTiempo;

      });

    }, 1000);

    return () => clearInterval(interval);

  }, []);





  const construirResultadoFinal = () => {

    const planAreas = areasPlanRef.current || {};

    const logroAreas = areasLogroRef.current || {};



    const resultadosAreas = Array.from(

      new Set([

        ...Object.keys(planAreas),

        ...Object.keys(logroAreas)

      ])

    )

      .map((area) => {

        const puntajeMaximo = planAreas[area] || 0;

        const puntajeObtenido = logroAreas[area] || 0;

        const porcentaje =

          puntajeMaximo > 0

            ? Math.round((puntajeObtenido / puntajeMaximo) * 100)

            : 0;



        return {

          area,

          puntajeObtenido,

          puntajeMaximo,

          porcentaje

        };

      })

      .filter((resultado) => resultado.puntajeMaximo > 0);



    const puntajeMaximoGlobal = totalPlanRef.current || 0;

    const puntajeObtenidoGlobal = totalLogroRef.current || 0;

    const desempenoGlobal =

      puntajeMaximoGlobal > 0

        ? Math.round(

            (puntajeObtenidoGlobal / puntajeMaximoGlobal) * 100

          )

        : 0;



    return {

      resultadosAreas,

      puntajeMaximoGlobal,

      puntajeObtenidoGlobal,

      desempenoGlobal

    };

  };



  const finalizarNivel = async (resumenFinal) => {

    const response = await fetch(`${API_URL}/nivel-finalizar`, {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify({

        session_id: sessionIdRef.current,

        nombreUsuario: usuario,

        nivel: 'Avanzado',

        puntajeFinal: puntajeRef.current,

        puntajeObtenidoGlobal: resumenFinal.puntajeObtenidoGlobal,

        puntajeMaximoGlobal: resumenFinal.puntajeMaximoGlobal,

        desempenoGlobal: resumenFinal.desempenoGlobal,

        perdioPorVidas: perdioPorVidasRef.current,

        resultadosAreas: resumenFinal.resultadosAreas

      })

    });



    const text = await response.text();

    let data = {};



    if (text) {

      try {

        data = JSON.parse(text);

      } catch {

        data = {};

      }

    }



    if (!response.ok || data.ok === false) {

      throw new Error(

        data.detalle ||

        data.error ||

        `No se pudo finalizar el nivel. HTTP ${response.status}`

      );

    }



    return data;

  };



  const guardarHistorial = (caso) => {

    const fechaISO = new Date().toISOString();

    const payload = {

      nombreUsuario: usuario,

      nivel: 'Avanzado',

      fechaHora: fechaISO,

      ultimoCasoCompletado: caso,

      puntaje: puntajeRef.current,

      tiempoEnSegundos: tiempoRef.current

    };



    const operacion = historialWriteQueueRef.current.then(async () => {

      const response = await fetch(`${API_URL}/guardar-historico`, {

        method: 'POST',

        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify(payload)

      });



      const text = await response.text();

      let data = {};



      if (text) {

        try {

          data = JSON.parse(text);

        } catch {

          data = {};

        }

      }



      if (!response.ok || data.ok === false) {

        throw new Error(

          data.mensaje ||

          data.error ||

          `No se pudo guardar el histórico. HTTP ${response.status}`

        );

      }



      return data;

    });



    historialWriteQueueRef.current = operacion.catch(() => {

      // Mantener operativa la cola aunque una escritura falle.

    });



    return operacion;

  };



  const reemplazarNombre = (texto) => {

    if (!texto) return '';

    const nombreFormateado = `<strong><em>${usuario}</em></strong>`;

    return texto.replace(/\[NombreUsuario\]/g, nombreFormateado).replace(/\n/g, '<br />');

  };



  const handleScore = (delta) => {

    const n = parseIntSafe(delta);

    if (!Number.isNaN(n)) {

      const nuevoPuntaje = puntajeRef.current + n;

      puntajeRef.current = nuevoPuntaje;

      setPuntaje(nuevoPuntaje);



      if (n > 0) {

        recordAreaLogroDelta(n);

        totalLogroRef.current += n;

        setTotalLogro(totalLogroRef.current);

      }

    }

  };



  const registrarRespuesta = async ({ respuesta_usuario, es_correcta }) => {

    try {

      const session_id = sessionIdRef.current;



      const payload = {

        session_id,

        nombreUsuario: usuario,

        nivel: 'Avanzado',

        pregunta_id: preguntaActual?.ID,

        tipo_pregunta: 'swipe',

        respuesta_usuario,

        es_correcta: es_correcta ?? null,

        tiempo_seg: tiempo,

        device: /Mobi/.test(navigator.userAgent) ? 'mobile' : 'desktop',

        score_before: puntajeRef.current,

        __debug_client_ts: new Date().toISOString()

      };



      const res = await fetch(`${API_URL}/api/answer?debug=1`, {

        method: 'POST',

        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify(payload)

      });



      await res.text();

    } catch (err) {

      console.error('❌ Error registrando respuesta:', err);

    }

  };



  const handleStart = (x, tipo) => {

    if (!bloquearInteraccion && !swipePendiente && !confirmandoSwipeRef.current && !mostrarImagen && getTipo(preguntaActual) === 'swipe') {

      inputTipo.current = tipo;

      setStartX(x);

    }

  };



  const handleEnd = (tipo) => {
    if (getTipo(preguntaActual) !== 'swipe' || startX === null ||
        bloquearInteraccion || swipePendiente || mostrarImagen ||
        tipo !== inputTipo.current || handleEndCalledRef.current) return;

    handleEndCalledRef.current = true;
    const opcion = posicionX <= -120 ? 'A' : posicionX >= 120 ? 'B' : null;
    setStartX(null);
    inputTipo.current = null;
    handleEndCalledRef.current = false;

    if (!opcion) {
      setPosicionX(0);
      return;
    }
    // Mantener tarjeta inclinada y alternativa verde seleccionable.
    setPosicionX(opcion === 'A' ? -135 : 135);
    setSwipePendiente(opcion);
  };

  // ÚNICO lugar que procesa puntaje, registro y vidas de respuestas Swipe.
  const confirmarSwipe = (letraElegida) => {
    if (confirmandoSwipeRef.current || !swipePendiente ||
        letraElegida !== swipePendiente || bloquearInteraccion) return;
    confirmandoSwipeRef.current = true;
    setSwipePendiente(null);
    handleEndCalledRef.current = true;

    const puntajeTexto = letraElegida === 'A'
      ? (preguntaActual.PuntajeA || '')
      : (preguntaActual.PuntajeB || '');
    const efecto = letraElegida === 'A'
      ? (preguntaActual.FeedbackA_HTML || preguntaActual.FeedbackA)
      : (preguntaActual.FeedbackB_HTML || preguntaActual.FeedbackB);
    const siguiente = letraElegida === 'A'
      ? preguntaActual.SiguienteIDA
      : preguntaActual.SiguienteIDB;

    // === determinar es_correcta para logging (true | false | "Info")

    const esInfo = isInfoValue(puntajeTexto);

    const parsed = parseInt(puntajeTexto, 10);

    const tieneNumero = !Number.isNaN(parsed);

    const esCorrectaBool = tieneNumero ? parsed > 0 : false;

    const es_correcta = esInfo ? 'Info' : (esCorrectaBool ? true : false);

    console.log('[DEBUG swipe]', {

      id: preguntaActual?.ID,

      letraElegida,

      puntajeTexto,

      esInfo,

      parsed,

      tieneNumero,

      esCorrectaBool,

      es_correcta_tipo: typeof es_correcta,

      es_correcta_valor: es_correcta

    });



    // log de la respuesta swipe

    registrarRespuesta({ respuesta_usuario: letraElegida, es_correcta });



    // === Rama "INFO": solo mostrar feedback y avanzar, sin afectar vidas/puntaje

    if (esInfo) {

      if (!tiempoInicioCaso && preguntaActual.Caso) {

        setTiempoInicioCaso(Date.now());

        setUltimoCaso(preguntaActual.Caso);

      }



      setBloquearInteraccion(true);

      setMostrarOpciones(false);



      const esperar = String(preguntaActual.EsperarOK || '').toLowerCase() === 'sí' ||

                      String(preguntaActual.EsperarOK || '').toLowerCase() === 'si';

      setEsperarOk(esperar);

      if (esperar) setPreguntaPendiente(siguiente);



      const hayFb = (efecto || '').trim() !== '';



      setTimeout(() => {

        setMostrarEfectoEnPantalla(true);

        setTextoEfectoPantalla(reemplazarNombre(efecto)); // ⬅️ HTML permitido

        handleEndCalledRef.current = false;

      }, 300);



      if (!esperar) {

        if (hayFb) {

          setTimeout(() => avanzar(siguiente), 2500);

        } else {

          avanzar(siguiente);

        }

      }

      return;

    }



    // === Rama numérica (comportamiento existente) ===

    let puntajeNum = parseIntSafe(puntajeTexto);

    let esNumerico = /^-?\d+$/.test(String(puntajeTexto).trim());

    let error = false;



    if (!esNumerico) {

      puntajeNum = 0;

      error = false; // no evaluable (ya cubierto "info" arriba)

    } else {

      error = puntajeNum <= 0; // <=0 es incorrecta

    }



    handleScore(puntajeNum);



    if (!tiempoInicioCaso && preguntaActual.Caso) {

      setTiempoInicioCaso(Date.now());

      setUltimoCaso(preguntaActual.Caso);

    }



    setBloquearInteraccion(true);

    setMostrarOpciones(false);



    const esperar = String(preguntaActual.EsperarOK || '').toLowerCase() === 'sí' ||

                    String(preguntaActual.EsperarOK || '').toLowerCase() === 'si';

    setEsperarOk(!error && esperar);

    if (!error && esperar) setPreguntaPendiente(siguiente);



    setTimeout(() => {

      setMostrarEfectoEnPantalla(true);

      setTextoEfectoPantalla(reemplazarNombre(efecto)); // ⬅️ HTML permitido

      handleEndCalledRef.current = false;

    }, 300);



    if (!error && !esperar) {

      setTimeout(() => avanzar(siguiente), 2500);

    } else if (error) {

      setVidas(v => {

        const nuevasVidas = Math.max(v - 1, 0);

        if (nuevasVidas <= 0) {

          perdioPorVidasRef.current = true;

          setMostrarCartaFin(true);

          setPreguntaPendiente('1000');

        } else {

          setPreguntaPendiente(siguiente);

        }

        return nuevasVidas;

      });

      setModoError(true);

    }

  };



  const avanzar = async (siguiente) => {

    if (!siguiente) return;



    if (String(siguiente).toLowerCase() === 'fin') {

      if (finalizandoRef.current) return;

      finalizandoRef.current = true;



      if (String(preguntaActual?.ID || '').trim() === '1000') {

        perdioPorVidasRef.current = true;

      }



      try {

        const resumenFinal = construirResultadoFinal();



        await guardarHistorial(preguntaActual?.Caso || ultimoCaso);



        const resultado = await finalizarNivel(resumenFinal);

        setResultadoFinal(resultado);

        setMostrarResumen(true);

      } catch (error) {

        finalizandoRef.current = false;

        console.error('❌ Error al cerrar el nivel avanzado:', error);

      }



      return;

    }



    const proxima = preguntas.find(p => p.ID === String(siguiente));

    if (!proxima) return;



    if (

      preguntaActual?.Caso &&

      preguntaActual.Caso !== ultimoCasoGuardado.current

    ) {

      try {

        await guardarHistorial(preguntaActual.Caso);

        ultimoCasoGuardado.current = preguntaActual.Caso;

      } catch (error) {

        console.error('❌ Error al guardar avance del histórico:', error);

      }

    }



    if (proxima.Caso && proxima.Caso !== ultimoCaso) {

      setTiempoInicioCaso(null);

      setUltimoCaso(proxima.Caso);

    }



    confirmandoSwipeRef.current = false;
    setSwipePendiente(null);
    setPreguntaActual(proxima);

    setPosicionX(0);

    setStartX(null);

    setMostrarEfectoEnPantalla(false);

    setTextoEfectoPantalla('');

    setBloquearInteraccion(false);

    setMostrarOpciones(true);

    setModoError(false);

    setEsperarOk(false);

    setPreguntaPendiente(null);

  };



  const continuarDespuesDeError = () => {

    if (mostrarCartaFin) {

      const cartaFin = preguntas.find(p => p.ID === '1000');

      if (cartaFin) {

        confirmandoSwipeRef.current = false;
        setSwipePendiente(null);
        setPreguntaActual(cartaFin);

        setMostrarCartaFin(false);

        setMostrarEfectoEnPantalla(false);

        setTextoEfectoPantalla('');

        setMostrarOpciones(true);

        setModoError(false);

        setPreguntaPendiente(null);

        setBloquearInteraccion(false);

        setPosicionX(0);

        setStartX(null);

        return;

      }

    }

    avanzar(preguntaPendiente);

    handleEndCalledRef.current = false;

    setModoError(false);

    setPreguntaPendiente(null);

  };



  const descontarVida = () => {

    let remaining = null;



    setVidas((v) => {

      const nv =

        Math.max(v - 1, 0);



      remaining =

        nv;



      if (nv <= 0) {

        perdioPorVidasRef.current = true;
        setMostrarCartaFin(true);
        setPreguntaPendiente('1000');

      }



      return nv;

    });



    return remaining;

  };





  const renderPregunta = () => {

    if (!preguntaActual) return null;



    switch (getTipo(preguntaActual)) {

      case 'imagenes3':

        return (

          <Images3Question

            pregunta={preguntaActual}

            onNext={avanzar}

            reemplazarNombre={reemplazarNombre}

            resolveImg3={resolveImg3}

            onScore={handleScore}

            onLoseLife={descontarVida}

            getLives={() => vidas}

            noLivesId="1000"

          />

        );

      case 'alternativasgraficas':

        return (

          <AlternativasGraficas

            pregunta={preguntaActual}

            onNext={avanzar}

            onScore={handleScore}

            onLoseLife={descontarVida}

            reemplazarNombre={reemplazarNombre}

            resolveGeneral={resolveGeneral}

            getLives={() => vidas}

            noLivesId="1000"

          />

        );

      case 'swipe':

      default:

        return (

          <div

            className="swipe-container"

            style={{ touchAction: 'pan-y', zIndex: 5 }}

            onTouchStart={(e) => handleStart(e.touches[0].clientX, 'touch')}

            onTouchMove={(e) => handleMove(e.touches[0].clientX)}

            onTouchEnd={() => handleEnd('touch')}

            onMouseDown={(e) => handleStart(e.clientX, 'mouse')}

            onMouseMove={(e) => startX !== null && handleMove(e.clientX)}

            onMouseUp={() => handleEnd('mouse')}

            onMouseLeave={() => handleEnd('mouse')}

          >

            {mostrarOpciones && (

              <>

                <button
                    type="button"
                    className={`opcion-izquierda ${posicionX < -30 ? 'mostrar' : ''} ${swipePendiente === 'A' ? 'opcion-swipe-confirmable' : ''}`}
                    disabled={swipePendiente !== 'A'}
                    onClick={(e) => { e.stopPropagation(); confirmarSwipe('A'); }}
                    aria-label="Confirmar alternativa A"
                  >

                  <span

                    dangerouslySetInnerHTML={{

                      __html: reemplazarNombre(preguntaActual.OpcionA_HTML || preguntaActual.OpcionA || '')

                    }}

                  />

                </button>

                <button
                    type="button"
                    className={`opcion-derecha ${posicionX > 30 ? 'mostrar' : ''} ${swipePendiente === 'B' ? 'opcion-swipe-confirmable' : ''}`}
                    disabled={swipePendiente !== 'B'}
                    onClick={(e) => { e.stopPropagation(); confirmarSwipe('B'); }}
                    aria-label="Confirmar alternativa B"
                  >

                  <span

                    dangerouslySetInnerHTML={{

                      __html: reemplazarNombre(preguntaActual.OpcionB_HTML || preguntaActual.OpcionB || '')

                    }}

                  />

                </button>

              </>

            )}



            {mostrarEfectoEnPantalla && textoEfectoPantalla.trim() !== '' ? (

              <div className="efecto-desplegado">

                <p dangerouslySetInnerHTML={{ __html: textoEfectoPantalla }} />

                {(modoError || esperarOk) && hayImagenValida && (

                  <button className="btn-ver-imagen" onClick={() => setMostrarImagen(true)}>📷 Ver imagen</button>

                )}

                {(modoError || esperarOk) && (

                  <button className="btn-ok-continuar" onClick={continuarDespuesDeError}>✅ Ok</button>

                )}

              </div>

            ) : (

              <div className="carta-deslizable">

                <div className="imagen-y-boton" style={{ position: 'relative' }}>

                  {resolveRol(preguntaActual?.Rol) && (

                    <img

                      draggable="false"

                      src={resolveRol(preguntaActual?.Rol)}

                      alt={preguntaActual?.Rol || 'rol'}

                      className="img-enfermera"

                      style={{ transform: `translateX(${posicionX}px) rotate(${posicionX / 30}deg)`, transition: 'transform 0.5s ease' }}

                    />

                  )}

                  {(preguntaActual.Imagen || preguntaActual.ImagenGral) &&

                   resolveGeneral(preguntaActual.Imagen || preguntaActual.ImagenGral) && (

                    <button

                      className="btn-ver-imagen"

                      style={{ position: 'absolute', top: '1px', left: '50%', transform: 'translateX(-50%)', zIndex: 2 }}

                      onClick={(e) => { e.stopPropagation(); setMostrarImagen(true); }}

                    >

                      📷 Ver imagen

                    </button>

                  )}

                </div>

              </div>

            )}

          </div>

        );

    }

  };



  if (cargando || !preguntaActual) {

    return (

      <div className="cargando" style={{ backgroundImage: `url(${fondo})` }}>

        <div className="cuadro-carga">

          {cargando ? '⏳ Cargando preguntas...' : '❌ No se pudo cargar la pregunta.'}

        </div>

      </div>

    );

  }



  if (mostrarResumen) {

    const areaNames = Array.from(new Set([

      ...Object.keys(areasPlan || {}),

      ...Object.keys(areasLogro || {})

    ]));

    const resumenAreas = areaNames

      .map(a => {

        const plan = areasPlan[a] || 0;

        const logro = areasLogro[a] || 0;

        const pct = plan > 0 ? Math.round((logro / plan) * 100) : 0;

        return { area: a, plan, logro, pct };

      })

      .filter(x => x.plan > 0)

      .sort((a, b) => a.pct - b.pct);



    const pctGlobalCalculado =

      totalPlan > 0

        ? Math.round(

            (totalLogro / totalPlan) * 100

          )

        : 0;



    const pctGlobal =

      Number.isFinite(Number(resultadoFinal?.desempenoGlobal))

        ? Number(resultadoFinal.desempenoGlobal)

        : pctGlobalCalculado;



    const aprobado = resultadoFinal?.aprobado === true;

    const porcentajeMinimo =

      Number.isFinite(Number(resultadoFinal?.porcentajeMinimo))

        ? Number(resultadoFinal.porcentajeMinimo)

        : 0;



    return (

      <div className="nivel-basico-container" style={{ backgroundImage: `url(${fondo})` }}>

        <div className="tarjeta-resumen">

          <h2>🏁 ¡Nivel Avanzado Finalizado! 🏁</h2>

          <p className="resumen-texto">

            {aprobado ? '👏 ¡Nivel aprobado!,' : '❌ Nivel no aprobado,'}{' '}

            <strong>{usuario.toUpperCase()}</strong>

          </p>

          <p className="resumen-texto">🏅 Puntaje final: <strong>{puntaje}</strong></p>



          <div className="resumen-global kpi">

            <div className="kpi-title"> Desempeño global: <div className="kpi-metric"><strong>{pctGlobal}%</strong></div></div>

            <div className="progress">

              <div className="bar">

                <div className="bar-fill" style={{ width: `${pctGlobal}%` }} />

              </div>

            </div>

          </div>



          <p className="resumen-texto">

            Mínimo requerido: <strong>{porcentajeMinimo}%</strong>

          </p>



          {!aprobado && (

            <p className="resumen-texto">

              {resultadoFinal?.motivo === 'sin_vidas'

                ? 'Perdiste todos tus corazones. Debes repetir el nivel.'

                : 'No alcanzaste el desempeño mínimo. Debes repetir el nivel.'}

            </p>

          )}



          {resumenAreas.length > 0 && (

            <div className="resumen-areas">

              <div className="kpi-title"> Desempeño por Área</div>

              <ul className="lista-areas barras">

                {resumenAreas.map(({ area, pct }) => (

                  <li className="area-row" key={area}>

                    <div className="area-header">

                      <strong>{area}</strong>

                      <span className="area-pct">{pct}%</span>

                    </div>

                    <div className="progress small">

                      <div className="bar">

                        <div className="bar-fill" style={{ width: `${pct}%` }} />

                      </div>

                    </div>

                  </li>

                ))}

              </ul>

            </div>

          )}



          <div className="resumen-botones">

            <button className="btn-logout" onClick={() => { localStorage.removeItem('usuario'); window.location.href = "/"; }}>

              🔒 Logout

            </button>

            <button
              className="btn-volver"
              onClick={() => {
                if (aprobado) {
                  sessionStorage.setItem('videoFinalHabilitado', 'true');
                  navigate('/video-final');
                } else {
                  navigate('/seleccionar-nivel');
                }
              }}
            >
              {aprobado ? '🎬 Continuar' : '🔁 Volver al Inicio'}
            </button>

          </div>

        </div>

      </div>

    );

  }



  return (

    <div className="nivel-basico-container" style={{ backgroundImage: `url(${fondo})` }}>

      <div className="estructura">

        <div className="barra-superior">

          <span className="usuario">👤 {usuario.toUpperCase()}</span>

          <div className="vidas-barra">

            {Array.from({ length: 5 }).map((_, index) => (

              <span key={index}>{index < vidas ? '❤️' : '🤍'}</span>

            ))}

          </div>

          <span className="barra-tiempo">

            ⏱ {Math.floor(tiempo / 60)}:{('0' + (tiempo % 60)).slice(-2)}

          </span>

        </div>



        <div className="bloque-central">

          <div className="titulo-y-pregunta">

            {preguntaActual.Titulo && (

              <div

                className="titulo-carta"

                dangerouslySetInnerHTML={{ __html: preguntaActual.TituloHTML || preguntaActual.Titulo }}

              />

            )}

            <p

              className="texto-pregunta"

              dangerouslySetInnerHTML={{ __html: reemplazarNombre(preguntaActual.FraseHTML || preguntaActual.Frase) }}

            />

          </div>



          {renderPregunta()}

        </div>

      </div>



      <div className="barra-inferior">

        {imgGenerales['escudo_udec'] && <img src={imgGenerales['escudo_udec']} alt="Escudo UdeC" />}

        <span className="puntaje-barra">Puntaje: {puntaje}</span>

        <span className="texto-izquierda"></span>

      </div>



      {mostrarImagen &&

      (preguntaActual?.Imagen || preguntaActual?.ImagenGral) &&

      resolveGeneral(preguntaActual.Imagen || preguntaActual.ImagenGral) && (

        <div className="modal-imagen" onClick={() => setMostrarImagen(false)}>

          <img

            src={resolveGeneral(preguntaActual.Imagen || preguntaActual.ImagenGral)}

            alt="Imagen asociada"

            className="imagen-expandida"

          />

          <button className="btn-cerrar-modal">✖️ Cerrar</button>

        </div>

      )}



      <WarningVidas

        lives={vidas}

        levelKey="avanzado"

        triggerAt={2}

        title="Atención!!!"

        message="Los pacientes están reclamando por tu desempeño ... Te quedan 2 oportunidades!"

        imageKey="enfermera_molesta"

        resolveImg={resolveAny}

        onOpen={() => setBloquearInteraccion(true)}

        onClose={() => setBloquearInteraccion(false)}

        canShow={!mostrarEfectoEnPantalla && !modoError}

      />



      <ChatWidget />

    </div>

  );

};



export default NivelAvanzado;